import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_DOCUMENT_LIST: string = typeCreatorV2(
  'DocumentListReducer',
  'SetDocument'
);

export const CREATE_DOCUMENT: string = typeCreatorV2(
  'DocumentListReducer',
  'CreateDocument'
);

export const DELETE_DOCUMENT: string = typeCreatorV2(
  'DocumentListReducer',
  'DeleteDocument'
);

export const SET_TEXT_SEARCH: string = typeCreatorV2(
  'DocumentListReducer',
  'SetTextSearch'
);
